import CampaignSSOLoginContainer from "./CampaignSSOLoginContainer";
import LoginStore from "containers/Login/LoginStore";
export default LoginStore(CampaignSSOLoginContainer);